// ============================================================================
// JAPANESE TRANSLATIONS - JESUS IS NOT
// ============================================================================
// イエスが誰であるか（そして誰でないか）の明確化

export const jesusIsNot = [
  {
    category: "愛",
    text: "イエスは人種差別主義者ではありません - 出身に関係なくすべての人を平等に愛しています",
    reference: "ヨハネ4:9 - サマリヤの女はイエスが自分に話しかけることに驚く",
    context: "イエスは当時の文化的・人種的障壁を打ち破りました"
  },
  {
    category: "排除",
    text: "イエスは排他的ではありません - すべての人、特に疎外された人々を受け入れます",
    reference: "マタイ9:10-13 - イエスは取税人や罪人と食事をする",
    context: "イエスは社会から見捨てられ拒絶された人々を求めます"
  },
  {
    category: "裁き",
    text: "イエスは断罪しません - 裁くためではなく救うために来られました",
    reference: "ヨハネ3:17 - 神は御子を世に遣わしたのは、世をさばくためではない",
    context: "イエスの使命は救いと回復です"
  },
  {
    category: "暴力",
    text: "イエスは暴力的ではありません - 敵を愛することを教えています",
    reference: "マタイ5:44 - 自分の敵を愛しなさい",
    context: "イエスは急進的な愛によって正義の概念を革新しました"
  },
  {
    category: "富",
    text: "イエスは物質主義者ではありません - お金への愛に警告しています",
    reference: "マタイ6:24 - 神にも仕え、また富にも仕えるということはできません",
    context: "イエスは地上の宝より天の宝を優先します"
  },
  {
    category: "高慢",
    text: "イエスは高慢ではありません - へりくだって仕えます",
    reference: "ヨハネ13:5 - イエスは弟子たちの足を洗う",
    context: "イエスは偉大さが謙遜な奉仕にあることを示しました"
  },
  {
    category: "律法主義",
    text: "イエスは律法主義者ではありません - 儀式よりも憐れみを優先します",
    reference: "マタイ12:7 - わたしはあわれみは好むが、いけにえは好まない",
    context: "イエスは律法の核心を忘れた律法主義を批判します"
  },
  {
    category: "性別",
    text: "イエスは性差別主義者ではありません - 女性を尊重し評価します",
    reference: "ヨハネ4:27 - 弟子たちはイエスが女性と話していることに驚く",
    context: "イエスは当時の文化の家父長制的規範に挑戦しました"
  },
  {
    category: "権力",
    text: "イエスは暴君ではありません - 愛と模範によって導きます",
    reference: "マタイ20:28 - 人の子が来たのは、仕えられるためではなく、仕えるためです",
    context: "イエスはリーダーシップを犠牲的な奉仕として再定義しました"
  },
  {
    category: "復讐",
    text: "イエスは復讐心に満ちていません - 赦し、回復させます",
    reference: "ルカ23:34 - 父よ。彼らをお赦しください。彼らは、何をしているのか自分でわからないのです",
    context: "イエスは十字架上でさえも急進的な赦しを実践しました"
  },
  {
    category: "無関心",
    text: "イエスは無関心ではありません - 苦しむ人々に心を動かされます",
    reference: "マタイ9:36 - 群衆を見て、彼らをかわいそうに思われた",
    context: "イエスは苦しむ人々への深い共感を示します"
  },
  {
    category: "エリート",
    text: "イエスはエリート主義者ではありません - 普通の人々に囲まれています",
    reference: "マルコ1:16-20 - イエスは漁師を弟子として召す",
    context: "イエスは並外れた使命のために普通の人々を選びました"
  },
  {
    category: "偽善",
    text: "イエスは偽善者ではありません - 教えることを生きています",
    reference: "ヨハネ8:46 - あなたがたのうちだれが、わたしに罪があると責めることができますか",
    context: "イエスは言葉と行動の間の矛盾を見つけるよう挑戦します"
  },
  {
    category: "硬直",
    text: "イエスは硬直していません - 各人に合わせて教えを調整します",
    reference: "ヨハネ3 - イエスはニコデモとサマリヤの女性に異なる方法で話す",
    context: "イエスは各人の必要に応じてメッセージを個別化します"
  },
  {
    category: "伝統",
    text: "イエスは盲目的な伝統主義者ではありません - 抑圧的な伝統に疑問を呈します",
    reference: "マルコ7:13 - あなたがたの言い伝えによって神のことばを空文にしています",
    context: "イエスは人間の伝統より律法の精神を優先します"
  },
  {
    category: "国家主義",
    text: "イエスは国家主義者ではありません - 御国は国境を超えています",
    reference: "マタイ28:19 - あらゆる国の人々を弟子としなさい",
    context: "イエスの使命は普遍的で、一つの民に限定されていません"
  },
  {
    category: "分裂",
    text: "イエスは分裂させません - 信者の一致のために祈ります",
    reference: "ヨハネ17:21 - 彼らがみな一つとなるために",
    context: "言葉の戦いを作る代わりに多様性を祝いましょう"
  },
  {
    category: "真実",
    text: "イエスは嘘つきではありません - 嘘と操作を暴きます",
    reference: "ヨハネ8:44 - 悪魔は偽りの父です",
    context: "イエスは魂を傷つける嘘と操作を暴露します"
  },
  {
    category: "寛大さ",
    text: "イエスはけちではありません - 十分の一をはるかに超える寛大さです",
    reference: "ルカ21:3 - この貧しいやもめは、どの人よりもたくさん投げ入れました",
    context: "イエスの寛大さは十分の一の義務より強いのです"
  },
  {
    category: "正義",
    text: "イエスは沈黙の共犯者ではありません - 健全な正義によって守ります",
    reference: "マタイ18:6 - わたしを信じるこの小さい者たちのひとりにでもつまずきを与えるような者は",
    context: "他者を守らずに過ちを隠す沈黙はイエスの知恵ではありません"
  }
];

export default jesusIsNot;
